module.exports = __webpack_public_path__ + "static/media/Navbar03.32a09988.jpg";